import { configureStore } from "@reduxjs/toolkit";
import tokenSlice from "../slice/tokenSlice";
import userSlice from "../slice/userSlice";
import ticketTokenSlice from "../slice/ticketToken";

const store = configureStore({
  reducer: {
    token: tokenSlice,
    user: userSlice,
    ticket_token: ticketTokenSlice,
  },
});

export default store;
